/**
 * NOTE:
 * - R7 April [established:新設]
 */

import { t } from "i18next"
import { AdditionType } from "../../../../../constants/enums/additioinType"
import { Field } from "../fields"
import { Version, getCurrentVersion } from "@project/shared"
import { Moment } from "moment"

/**
 * Version management: Child Disorder Type Options
 * @param {Moment} date
 * @return {Field|null}
 */
export function getSupportProgramNotPublicizedSubtraction(date: Moment) {
  const { version } = getCurrentVersion(date.format("YYYY-MM-DD"))

  switch (version) {
    case Version.BASELINE:
    case Version.R6_APRIL:
    case Version.R6_JUNE:
    case Version.R7_JANUARY:
      return null

    default:
      return r7April
  }
}

/**
 * --------------------------------
 * @version R7_APRIL
 * --------------------------------
 */

/**
 * TODO: translate
 * @en
 * @ja 支援プログラム未公表減算
 */
const r7April: Field = {
  label: "支援プログラム未公表減算",
  name: AdditionType.SUPPORT_PROGRAM_NOT_PUBLICIZED_SUBTRACTION,
  fields: [
    {
      label: t("No change"),
      value: 0,
    },
    {
      label: t("No"),
      value: 1,
    },
    {
      label: t("Yes"),
      value: 2,
    },
  ],
}

/**
 * --------------------------------
 * @version BASELINE
 * @version R6_APRIL
 * @version R6_JUNE
 * @version R6_JANUARY
 *
 * NONE
 * --------------------------------
 */
